import { Lock } from "lucide-react";
import { useEffect, useRef } from "react";
import { AppShell } from "@/components/layout/AppShell";
import { BrandButton } from "@/components/kit/BrandButton";
import { EmptyState } from "@/components/kit/EmptyState";
import { useAuth } from "@/lib/auth";
import { track } from "@/lib/analytics";

/** Shown when the customer is signed in but does not own the requested program. */
export const NoAccess = ({ title = "Program" }) => {
  const { upgradeUrl } = useAuth();
  const reported = useRef(false);

  useEffect(() => {
    if (reported.current) return;
    reported.current = true;
    track("access_denied", {
      reason: "program_not_owned",
      page_path: window.location.pathname,
    });
  }, []);

  return (
    <AppShell title={title} showBack size="reading">
      <div data-testid="page-no-access" className="contents">
        <EmptyState
          icon={Lock}
          title="You don't have access to this program"
          description="If you've just purchased it, give it a moment and refresh — access updates automatically from your Plattershare account."
        >
          {upgradeUrl && (
            <BrandButton as="a" name="no-access-browse" href={upgradeUrl} target="_blank" rel="noopener">
              View meal plans
            </BrandButton>
          )}
        </EmptyState>
      </div>
    </AppShell>
  );
};
